import { INPUT_TYPE } from "../../../human-organization/summary-employee-request/constant";
import { department } from "../../../info-technology-process/data";

export const eContent = {
  toolName: "toolName", // tên sản phẩm
  Dram: "Dram", // đơn vị tính
  toolId: "toolId", // Mã CCDC
  Quantity: "Quantity", //Số lượng (*)
  reason: "reason" //Lí do
};

export const formFields1 = [
  {
    type: INPUT_TYPE.SELECT,
    options: department,
    label: "Cơ quan/Đơn vị",
    require: true,
    field: "eDepartment",
    span: 12,
    placeholder: "Chọn Cơ quan/Đơn vị",
  }
];

export const formFields2 = [
  {
    type: INPUT_TYPE.TEXT,
    label: "Số điện thoại",
    require: true,
    field: "ePhoneNumber",
    span: 12,
    placeholder: "Nhập số điện thoại",
  }
];
